import React, { useState, useEffect } from 'react'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import {
  FlexboxGrid,
  Grid,
  Row,
  Col,
  Panel,
  Table,
  SelectPicker,
  InputGroup,
  InputNumber,
  RangeSlider,
  CheckPicker,
  CheckTreePicker,
  Button,
  Nav,
  Icon,
  Whisper,
  Tooltip,
} from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import './styles.css'
import ResponsiveNav from '@rsuite/responsive-nav'
import OverAllNodeProjects from '../../widgets/dashboard/overviewDepartment6/OverAllNodeProjects'
import { DASHBOARD_DISPLAY_TYPE } from '../../constants/dashboardDep6'
import BasicKnowledgeAndSkillsAssScore from '../../widgets/dashboard/overviewDepartment6/BasicKnowledgeAndSkillsAssScore'
import ProjectsDevelopment from '../../widgets/dashboard/overviewDepartment6/ProjectsDevelopment'
import ActionResearchEvaluation from '../../widgets/dashboard/overviewDepartment6/ActionResearchEvaluation'
import CommunityCoalitionActionTheory from '../../widgets/dashboard/overviewDepartment6/CommunityCoalitionActionTheory'
import PartnershipAssessmentTools from '../../widgets/dashboard/overviewDepartment6/PartnershipAssessmentTools'
import OverAllOperations4areas from '../../widgets/dashboard/overviewDepartment6/OverAllOperations4areas'
import { getDashboardLanding } from '../../redux/actions/dashboardDep6'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'

export default function LandingDashboardOverview() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  // const [response, setResponse] = useState()
  const [active, setActive] = useState()
  const [schema, setSchema] = useState()

  useEffect(() => {
    handleGetResponse()
  }, [])

  const mockSchema = {
    header: '',
    form: {
      menuItem: [
        {
          menuLabel: 'ภาพรวมโครงการย่อย',
          eventKeyName: 'dash_1',
        },
        {
          menuLabel: 'คะแนนประเมินความรู้และทักษะพื้นฐาน สำนัก 6',
          eventKeyName: 'dash_2',
        },
        {
          menuLabel: 'พัฒนาข้อเสนอโครงการสร้างเสริมสุขภาพ (Project Development: PD)',
          eventKeyName: 'dash_3',
        },
        {
          menuLabel: 'ข้อมูลผลประเมินเรื่องการติดตามเชิงผลลัพธ์เพื่อการเรียนรู้และพัฒนา',
          eventKeyName: 'dash_4',
        },
        {
          menuLabel: 'ประเมินการถอดบทเรียนโครงการ (Community Coalition Action Theory: CCAT)',
          eventKeyName: 'dash_5',
        },
        {
          menuLabel: 'การประเมินความสัมพันธ์ภาคีหุ้นส่วน (Partnership Assessment Tools: PAT)',
          eventKeyName: 'dash_6',
        },
        {
          menuLabel: 'รายงานผลการประเมินสมรรถนะหน่วยจัดการ',
          eventKeyName: 'dash_7',
        },
      ],
    },
  }

  const handleGetResponse = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const res = await getDashboardLanding()
      console.log('res => ', res.form.activeMenu)

      setSchema(res)
      setActive(res?.form?.activeMenu || DASHBOARD_DISPLAY_TYPE.DASHBOARD_1)
    } catch (e) {
      console.log('error => ', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelect = (activeKey) => {
    console.log('active => ', activeKey)
    setActive(activeKey)
  }

  const landerWidgetsDashboard = (type) => {
    switch (type) {
      case DASHBOARD_DISPLAY_TYPE.DASHBOARD_1:
        return <OverAllNodeProjects />
        break

      case DASHBOARD_DISPLAY_TYPE.DASHBOARD_2:
        return <BasicKnowledgeAndSkillsAssScore />
        break

      case DASHBOARD_DISPLAY_TYPE.DASHBOARD_3:
        return <ProjectsDevelopment />
        break

      case DASHBOARD_DISPLAY_TYPE.DASHBOARD_4:
        return <ActionResearchEvaluation />
        break

      case DASHBOARD_DISPLAY_TYPE.DASHBOARD_5:
        return <CommunityCoalitionActionTheory />
        break

      case DASHBOARD_DISPLAY_TYPE.DASHBOARD_6:
        return <PartnershipAssessmentTools />
        break

      case DASHBOARD_DISPLAY_TYPE.DASHBOARD_7:
        return <OverAllOperations4areas />
        break

      default:
        break
    }
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
    // return (
    //   <Grid className="page-home">
    //     <TopLevelNav />
    //     <PageToolbar />
    //     <Row>
    //       <FlexboxGrid align="middle" className="banner">
    //         <FlexboxGrid.Item componentClass={Col} colspan={24} md={24}>
    //           <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
    //         </FlexboxGrid.Item>
    //       </FlexboxGrid>
    //     </Row>
    //   </Grid>
    // )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
    // return (
    //   <Grid className="page-home">
    //     <TopLevelNav />
    //     <PageToolbar />
    //     <Row>
    //       <FlexboxGrid align="middle" className="banner">
    //         <FlexboxGrid.Item componentClass={Col} colspan={24} md={24}>
    //           <Panel
    //             bordered
    //             style={{
    //               backgroundColor: '#34a888',
    //             }}
    //           >
    //             <OverlayLoader />
    //             <PanalLoadingTemplate />
    //           </Panel>
    //         </FlexboxGrid.Item>
    //       </FlexboxGrid>
    //     </Row>
    //   </Grid>
    // )
  }

  return (
    <>
      <SidebarProposal isAssessment>
        {/* <div style={{ marginTop: 50, fontSize: 16, marginBottom: 20 }} className="custom-dashboard"> */}
        {/* <TopLevelNav />
          <PageToolbar /> */}

        <Panel bordered shaded>
          {/* <div className="gggggg"> */}
          <ResponsiveNav
            removable
            appearance="tabs"
            moreText={<Icon icon="more" />}
            moreProps={{ noCaret: true }}
            // activeKey={active}
          >
            {schema?.form?.menuItem?.map((item) => (
              <Whisper
                placement="bottom"
                trigger="hover"
                speaker={<Tooltip>{item.menuLabel}</Tooltip>}
              >
                <ResponsiveNav.Item
                  key={item.eventKeyName}
                  eventKey={item?.eventKeyName || ''}
                  activeKey={active}
                  onSelect={(eventKey) => {
                    setActive(eventKey)
                  }}
                  // className="gggeee"
                  style={{ width: `${100 / schema?.form?.menuItem?.length}%` }}
                >
                  {item?.menuLabel ? `${item.menuLabel?.substring(0, 20)}...` : ''}
                </ResponsiveNav.Item>
              </Whisper>
            ))}
          </ResponsiveNav>
          {/* </div> */}

          <div>{landerWidgetsDashboard(active)}</div>
        </Panel>
        {/* </div> */}
      </SidebarProposal>
    </>
  )
}
